<template>
    <BaseDetailDialog></BaseDetailDialog>
</template>
<script>
import BaseDetailDialog from './baseDetailDialog.vue';
import bus from '@/utils/bus';
export default {
    components: {
        BaseDetailDialog
    },
    mounted() {
        const { id, name } = this.$route.query;
        bus.$emit('baseParam', id, name);
    }
};
</script>
